import React from "react";
import BreadcrumbOption from "../components/breadcrumb/Index";
function Recognitions(props) {
  return (
    <div>
      <BreadcrumbOption home={"Home"} current={"Awards & Recognitions"} />
    </div>
  );
}

export default Recognitions;
